import { useState, useRef, useEffect, useCallback, memo } from 'react';
import { createPortal } from 'react-dom';
import QRCode from 'qrcode';
import { LINK_TYPES, WALLPAPERS, CATEGORIES, LEAD_FIELDS } from '../../data/nfcData';
import { Bdg, Toggle, PH } from '../../components/shared';
import * as api from '../../services/api';
import { ModalScanCard } from './ModalScanCard';
import { ConfirmModal } from '../campaigns/ConfirmModal';

export const LiveCardPreview = memo(({form, showCaptureForm}) => (
  <div style={{position:"sticky",top:20}}>
    <div className="ue-preview-label" style={{marginBottom:10}}>LIVE PREVIEW</div>
    {/* Phone frame */}
    <div style={{position:"relative",width:240,margin:"0 auto",background:"#f1f5f9",borderRadius:36,padding:"10px 6px 18px",boxShadow:"0 12px 40px rgba(0,0,0,.12),0 4px 16px rgba(0,0,0,.08)",border:"1px solid rgba(0,0,0,.08)"}}>
      {/* Speaker notch */}
      <div style={{width:60,height:5,background:"#e2e8f0",borderRadius:3,margin:"0 auto 8px",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div style={{width:8,height:8,borderRadius:"50%",background:"#cbd5e1",border:"1px solid rgba(0,0,0,.06)"}}/>
      </div>
      {/* Screen */}
      <div className="popl-card" style={{borderRadius:28,overflow:"hidden",width:"100%",margin:0,boxShadow:"none"}}>
        {/* Wallpaper */}
        <div className="popl-wall" style={{
          height:110,
          background: form.wallpaperImg ? `url(${form.wallpaperImg}) center/cover` : form.wallpaper
        }}/>
        {/* Avatar */}
        <div style={{display:"flex",justifyContent:"center"}}>
          {form.avatarImg
            ? <div style={{width:70,height:70,borderRadius:"50%",border:"3px solid #fff",marginTop:-35,position:"relative",zIndex:2,boxShadow:"0 4px 16px rgba(0,0,0,.2)",overflow:"hidden",flexShrink:0}}>
                <img src={form.avatarImg} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
              </div>
            : <div className="popl-av" style={{background:form.grad,width:70,height:70,borderRadius:"50%",border:"3px solid #fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#fff",fontSize:22,marginTop:-35,zIndex:2,boxShadow:"0 4px 16px rgba(0,0,0,.2)"}}>
                {form.av}
              </div>
          }
        </div>
        {/* Info */}
        <div className="popl-info">
          <div className="popl-name">{form.firstName||"First"} {form.lastName||"Last"}</div>
          <div className="popl-pos" style={{fontSize:10.5}}>{form.jobTitle||form.position||"Position"}{form.company?" · "+form.company:""}</div>
          {form.bio && <div className="popl-bio">{form.bio.slice(0,70)}{form.bio.length>70?"…":""}</div>}
        </div>

        {/* Lead Capture Form overlay */}
        {showCaptureForm && form.captureEnabled ? (
          <div style={{margin:"10px 10px 0",background:"#f8fafc",borderRadius:14,padding:"12px 12px 8px",border:"1px solid #e2e8f0"}}>
            <div style={{fontSize:9.5,fontWeight:700,color:"#0f172a",marginBottom:8,textAlign:"center",letterSpacing:".04em"}}>CONNECT WITH {(form.firstName||"ME").toUpperCase()}</div>
            {form.captureFields.filter(f=>f.on).slice(0,3).map(f=>(
              <div key={f.label} style={{marginBottom:6}}>
                <div style={{fontSize:8.5,fontWeight:600,color:"#64748b",marginBottom:2,letterSpacing:".05em"}}>{f.label.toUpperCase()}</div>
                <div style={{height:22,borderRadius:6,background:"white",border:"1px solid #e2e8f0"}}/>
              </div>
            ))}
            {form.captureFields.filter(f=>f.on).length>3&&<div style={{fontSize:8.5,color:"#94a3b8",textAlign:"center",marginBottom:4}}>+{form.captureFields.filter(f=>f.on).length-3} more fields</div>}
            <div style={{height:24,borderRadius:8,background:"#0f172a",marginTop:6,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <div style={{fontSize:9.5,color:"white",fontWeight:700}}>Submit & Connect ›</div>
            </div>
          </div>
        ) : (
          /* Links */
          <div className="popl-links">
            {form.links.slice(0,4).map((lk,i)=>(
              <div key={i} className="popl-link">
                <div className="popl-link-ico" style={{background:lk.color+"18"}}>{lk.ico && lk.ico.startsWith('http') ? <img src={lk.ico} alt="" style={{width:16,height:16,objectFit:"contain"}}/> : <span style={{fontSize:14}}>{lk.ico || '🔗'}</span>}</div>
                <span className="popl-link-lbl">{lk.label}</span>
                <span className="popl-link-arr">›</span>
              </div>
            ))}
            {form.links.length===0&&<div style={{textAlign:"center",padding:"10px 0",fontSize:11,color:"#94a3b8"}}>No links added yet</div>}
          </div>
        )}

        {/* Footer */}
        <div style={{textAlign:"center",padding:"6px 0 10px",fontSize:9,color:"#cbd5e1",letterSpacing:".05em"}}>Powered by Gotaps ✦</div>
      </div>
    </div>
    {/* Mini stats */}
    <div style={{marginTop:14,display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:7}}>
      {[
        {lbl:"Links",   val:form.links.length,                          ico:"🔗",col:"#0891b2"},
        {lbl:"Fields",  val:form.captureFields.filter(f=>f.on).length,  ico:"📋",col:"#059669"},
        {lbl:"Devices", val:form.accessories.length,                    ico:"💳",col:"#7c3aed"},
      ].map(({lbl,val,ico,col})=>(
        <div key={lbl} style={{background:"rgba(255,255,255,.72)",border:"1px solid rgba(255,255,255,.9)",borderRadius:11,padding:"8px 6px",textAlign:"center",boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
          <div style={{fontSize:13,marginBottom:2}}>{ico}</div>
          <div style={{fontSize:15,fontWeight:740,color:col}}>{val}</div>
          <div style={{fontSize:9,color:"#94a3b8",fontWeight:550}}>{lbl}</div>
        </div>
      ))}
    </div>
  </div>
));

/* ── Main PageUserEdit ── */
export const PageUserEdit = memo(({member, onBack, onToast}) => {
  const [activeSection, setActiveSection] = useState("about");
  const [saved, setSaved] = useState(false);
  const [showCaptureForm, setShowCaptureForm] = useState(false);
  const walRef = useRef(null);
  const avRef  = useRef(null);
  const coverRef = useRef(null);
  const [apiPlatforms, setApiPlatforms] = useState(null);

  const email = member.email || "";
  const name = member.name || "";
  const uuid = member.card_uuid || ("usr_" + String(member.id).padStart(4,"0") + "x" + email.split("@")[0].slice(0,4));

  const [form, setForm] = useState({
    firstName:    member.firstName || name.split(" ")[0] || "",
    lastName:     member.lastName  || name.split(" ").slice(1).join(" ") || "",
    username:     member.username  || email.split("@")[0] || "",
    email:        email,
    phone:        member.phone     || "",
    workPosition: member.job_title || member.position || "",
    jobTitle:     member.job_title || member.position || "",
    company:      member.company   || "",
    address:      member.address   || "",
    category:     member.category  || "Sales",
    bio:          member.bio       || "",
    wallpaper:    member.cover_color || member.wallpaper || WALLPAPERS[0],
    wallpaperImg: member.cover_photo || null,
    grad:         member.profile_color || member.grad || "linear-gradient(150deg,#64748b,#059669)",
    av:           member.av   || (name ? name.slice(0,2).toUpperCase() : "??"),
    avatarImg:    member.photo || null,
    avatarFile:   null,
    wallpaperFile: null,
    links:        member.existingLinks || member.links || [],
    captureEnabled: !!member.is_leads_enabled,
    captureFields: (() => {
      const saved = member.lead_form_config ? (typeof member.lead_form_config === 'string' ? JSON.parse(member.lead_form_config) : member.lead_form_config) : null;
      return LEAD_FIELDS.map(f => {
        const match = saved ? saved.find(s => s.key === f.key) : null;
        return { ...f, on: match ? match.on : f.required };
      });
    })(),
    qrColor:    "#18181b",
    qrBg:       "#ffffff",
    qrStyle:    "squares",
    vbgMode:    "color",  // "solid" | "color" | "image"
    vbgColor1:  "#0c4a6e",
    vbgColor2:  "#0891b2",
    vbgAngle:   135,
    vbgImg:     null,
    sigTemplate: "modern",
    accessories: member.accessories || [],
  });
  const set = (k,v) => { setForm(f=>({...f,[k]:v})); setSaved(false); };

  /* ── Link helpers ── */
  const [linkSearch, setLinkSearch] = useState("");
  const [linkPickerOpen, setLinkPickerOpen] = useState(false);
  const [expandedLink, setExpandedLink] = useState(null);
  const addLink = (lt) => {
    set("links",[...form.links,{
      id:Date.now(), type:lt.type, label:lt.label, ico:lt.ico, color:lt.color, url:"",
      platformId:lt.platformId, baseUrl:lt.baseUrl||"", placeholder:lt.placeholder||"",
      input:lt.input||"url", description:lt.description||"", docFile:null,
    }]);
    setLinkPickerOpen(false);
    setLinkSearch("");
  };
  const updateLink = (id,field,val) => set("links", form.links.map(lk=>lk.id===id?{...lk,[field]:val}:lk));
  const removeLink = (id) => { set("links", form.links.filter(lk=>lk.id!==id)); if(expandedLink===id) setExpandedLink(null); };
  const moveLink   = (i,dir) => {
    const arr=[...form.links]; const j=i+dir;
    if(j<0||j>=arr.length) return;
    [arr[i],arr[j]]=[arr[j],arr[i]]; set("links",arr);
  };

  const validateUrl = (v) => /^https?:\/\/.+/i.test(v);
  const validateEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  const validatePhone = (v) => /^[+\d\s()-]{5,}$/.test(v);

  const handleSave = async () => {
    // Validate links
    for (const lk of form.links) {
      if (!lk.url && lk.input !== 'document') {
        onToast(`"${lk.label}" has no value. Please fill it or remove it.`, "error");
        setExpandedLink(lk.id);
        return;
      }
      if (lk.input === 'url' || lk.input === 'video_url') {
        if (lk.url && !validateUrl(lk.url)) {
          onToast(`"${lk.label}" needs a valid URL starting with http:// or https://`, "error");
          setExpandedLink(lk.id);
          return;
        }
      }
      if (lk.input === 'email') {
        if (lk.url && !validateEmail(lk.url)) {
          onToast(`"${lk.label}" needs a valid email address`, "error");
          setExpandedLink(lk.id);
          return;
        }
      }
      if (lk.input === 'phone') {
        if (lk.url && !validatePhone(lk.url)) {
          onToast(`"${lk.label}" needs a valid phone number`, "error");
          setExpandedLink(lk.id);
          return;
        }
      }
      if (lk.input === 'document' && !lk.url && !lk.docFile) {
        onToast(`"${lk.label}" needs a document uploaded`, "error");
        setExpandedLink(lk.id);
        return;
      }
    }

    try {
      // Save profile data
      const fd = new FormData();
      fd.append('name', `${form.firstName} ${form.lastName}`.trim());
      fd.append('username', form.username);
      fd.append('email', form.email);
      fd.append('phone', form.phone || '');
      fd.append('job_title', form.jobTitle || '');
      fd.append('company', form.company || '');
      fd.append('address', form.address || '');
      fd.append('bio', form.bio || '');
      fd.append('is_leads_enabled', form.captureEnabled ? '1' : '0');
      fd.append('lead_form_config', JSON.stringify(form.captureFields.map(f => ({ key: f.key, label: f.label, on: f.on }))));

      if (form.avatarFile) {
        fd.append('photo', form.avatarFile);
      } else if (!form.avatarImg && member.photo) {
        fd.append('profile_color', form.grad || '');
      }
      if (form.wallpaperFile) {
        fd.append('cover_photo', form.wallpaperFile);
      } else if (!form.wallpaperImg && member.cover_photo) {
        fd.append('cover_color', form.wallpaper || '');
      }
      if (!form.avatarImg && !form.avatarFile) {
        fd.append('profile_color', form.grad || '');
      }
      if (!form.wallpaperImg && !form.wallpaperFile) {
        fd.append('cover_color', form.wallpaper || '');
      }

      await api.updateMemberForm(member.id, fd);

      // Save links with order
      if (form.links.length > 0) {
        const linksPayload = form.links.map((lk, i) => ({
          platform_id: lk.platformId,
          path: lk.url || '',
          label: lk.label || '',
          order: i,
        }));
        await api.bulkSaveLinks(member.id, linksPayload);
      }

      setSaved(true);
      onToast(`Profile for ${form.firstName} ${form.lastName} saved!`);
    } catch (e) {
      let msg = e.message || "Failed to save profile";
      if (e.errors) {
        const firstErr = Object.values(e.errors)[0];
        msg = Array.isArray(firstErr) ? firstErr[0] : firstErr;
      }
      onToast(msg, "error");
    }
  };

  const NAV = [
    {id:"about",       ico:"👤", lbl:"About"},
    {id:"links",       ico:"🔗", lbl:"Links"},
    {id:"capture",     ico:"📋", lbl:"Lead Capture"},
    {id:"qr",          ico:"◻️", lbl:"QR Code"},
    {id:"vbg",         ico:"🖥️", lbl:"Virtual Bg"},
    {id:"signature",   ico:"✉️", lbl:"Email Sig"},
    {id:"accessories", ico:"💳", lbl:"Accessories"},
  ];

  /* VBG default images */
  const VBG_IMAGES = [
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80",
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80",
    "https://images.unsplash.com/photo-1606761568499-6d2451b23c66?w=800&q=80",
    "https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=800&q=80",
  ];

  /* SIG templates */
  const SIG_TEMPLATES = [
    {id:"modern",   lbl:"Modern",    accent:"#0891b2"},
    {id:"minimal",  lbl:"Minimal",   accent:"#334155"},
    {id:"classic",  lbl:"Classic",   accent:"#7c3aed"},
    {id:"bold",     lbl:"Bold",      accent:"#dc2626"},
    {id:"executive",lbl:"Executive", accent:"#d97706"},
    {id:"clean",    lbl:"Clean",     accent:"#059669"},
  ];

  /* ══════════ SECTIONS ══════════ */

  const SectionAbout = () => (
      <div>
        <div className="ue-section-title">About</div>
        <div className="ue-section-sub">Identity info shown at the top of the digital card</div>

        {/* ── UUID badge ── */}
        <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:20,padding:"9px 13px",background:"rgba(100,116,139,.07)",borderRadius:10,border:"1px solid rgba(100,116,139,.14)"}}>
          <div style={{fontSize:11,fontWeight:600,color:"#64748b"}}>UUID</div>
          <div style={{fontFamily:"monospace",fontSize:11.5,color:"#334155",flex:1,letterSpacing:".06em"}}>{uuid}</div>
          <button onClick={()=>{navigator.clipboard?.writeText(uuid);onToast("UUID copied!");}}
            style={{fontSize:11,padding:"3px 9px",borderRadius:7,border:"1px solid rgba(0,0,0,.1)",background:"rgba(255,255,255,.8)",cursor:"pointer",color:"#64748b",fontFamily:"var(--f)"}}>⧉ Copy</button>
        </div>

        {/* ── Profile Wallpaper / Cover Photo ── */}
        <div className="fg">
          <label>Cover Photo <span style={{fontSize:10,color:"#94a3b8",fontWeight:400}}>· Recommended: 1125 × 633px (16:9)</span></label>
          <div style={{height:90,borderRadius:14,overflow:"hidden",position:"relative",marginBottom:10,boxShadow:"0 4px 16px rgba(0,0,0,.12)",background:form.wallpaperImg?`url(${form.wallpaperImg}) center/cover`:form.wallpaper}}>
            <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",gap:9,opacity:0,transition:"opacity .18s",background:"rgba(0,0,0,.3)"}}
              onMouseEnter={e=>e.currentTarget.style.opacity=1}
              onMouseLeave={e=>e.currentTarget.style.opacity=0}>
              <button onClick={()=>walRef.current?.click()} style={{padding:"6px 14px",borderRadius:8,border:"none",background:"rgba(255,255,255,.9)",cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"var(--f)"}}>Upload Image</button>
              {form.wallpaperImg&&<button onClick={()=>set("wallpaperImg",null)} style={{padding:"6px 14px",borderRadius:8,border:"none",background:"rgba(220,38,38,.9)",color:"white",cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"var(--f)"}}>Remove</button>}
            </div>
          </div>
          <input ref={walRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
            const f=e.target.files[0]; if(!f) return;
            set("wallpaperFile", f);
            const r=new FileReader(); r.onload=ev=>set("wallpaperImg",ev.target.result); r.readAsDataURL(f);
          }}/>
          {!form.wallpaperImg&&(
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {WALLPAPERS.map((w,i)=>(
                <div key={i} onClick={()=>set("wallpaper",w)}
                  style={{width:48,height:32,borderRadius:9,background:w,cursor:"pointer",transition:"all .15s",
                    border:form.wallpaper===w?"2.5px solid #0f172a":"2.5px solid transparent",
                    boxShadow:form.wallpaper===w?"0 0 0 3px rgba(0,0,0,.14)":"none"}}/>
              ))}
            </div>
          )}
          {form.wallpaperImg&&(
            <div style={{display:"flex",gap:8,alignItems:"center",marginTop:4}}>
              <span style={{fontSize:11.5,color:"#059669",fontWeight:600}}>✓ Custom image uploaded</span>
              <button onClick={()=>set("wallpaperImg",null)} style={{fontSize:11,padding:"2px 9px",borderRadius:6,border:"1px solid rgba(220,38,38,.2)",background:"rgba(220,38,38,.07)",color:"#dc2626",cursor:"pointer",fontFamily:"var(--f)"}}>Remove</button>
            </div>
          )}
        </div>

        {/* ── Profile Photo (Avatar) ── */}
        <div className="fg">
          <label>Profile Photo <span style={{fontSize:10,color:"#94a3b8",fontWeight:400}}>· Recommended: 400 × 400px (1:1)</span></label>
          <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:8}}>
            <div style={{position:"relative",flexShrink:0}}>
              {form.avatarImg
                ? <div style={{width:72,height:72,borderRadius:"50%",overflow:"hidden",border:"3px solid rgba(255,255,255,.9)",boxShadow:"0 4px 16px rgba(0,0,0,.15)"}}>
                    <img src={form.avatarImg} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                  </div>
                : <div style={{width:72,height:72,borderRadius:"50%",background:form.grad,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:22,color:"#fff",border:"3px solid rgba(255,255,255,.9)",boxShadow:"0 4px 16px rgba(0,0,0,.15)"}}>{form.av}</div>
              }
              <div onClick={()=>avRef.current?.click()}
                style={{position:"absolute",inset:0,borderRadius:"50%",background:"rgba(0,0,0,.42)",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",opacity:0,transition:"opacity .15s",fontSize:16}}
                onMouseEnter={e=>e.currentTarget.style.opacity=1}
                onMouseLeave={e=>e.currentTarget.style.opacity=0}>📷</div>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:7}}>
              <button onClick={()=>avRef.current?.click()} className="btn bp" style={{fontSize:12,padding:"6px 14px",gap:6}}>
                📷 Upload Photo
              </button>
              {form.avatarImg&&(
                <button onClick={()=>set("avatarImg",null)} className="btn bd" style={{fontSize:12,padding:"6px 14px",gap:6}}>
                  ✕ Remove Photo
                </button>
              )}
              {!form.avatarImg&&(
                <div style={{fontSize:11,color:"#94a3b8"}}>Or choose avatar color ↓</div>
              )}
            </div>
          </div>
          <input ref={avRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
            const f=e.target.files[0]; if(!f) return;
            set("avatarFile", f);
            const r=new FileReader(); r.onload=ev=>set("avatarImg",ev.target.result); r.readAsDataURL(f);
          }}/>
          {!form.avatarImg&&(
            <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:4}}>
              {["linear-gradient(150deg,#64748b,#059669)","linear-gradient(150deg,#18181b,#dc2626)","linear-gradient(150deg,#d97706,#dc2626)","linear-gradient(150deg,#059669,#64748b)","linear-gradient(150deg,#18181b,#64748b)","linear-gradient(150deg,#7c3aed,#0891b2)","linear-gradient(150deg,#0891b2,#06b6d4)","linear-gradient(150deg,#db2777,#f59e0b)"].map((g,i)=>(
                <div key={i} onClick={()=>set("grad",g)}
                  style={{width:34,height:34,borderRadius:"50%",background:g,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:800,color:"#fff",transition:"all .15s",
                    border:form.grad===g?"2.5px solid #0f172a":"2.5px solid transparent",
                    boxShadow:form.grad===g?"0 0 0 3px rgba(0,0,0,.14)":"none"}}>
                  {form.grad===g?"✓":""}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ── Fields grid ── */}
        <div className="frow">
          <div className="fg" style={{marginBottom:0}}><label>First Name</label><input className="inp" value={form.firstName} onChange={e=>set("firstName",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:0}}><label>Last Name</label><input className="inp" value={form.lastName} onChange={e=>set("lastName",e.target.value)}/></div>
        </div>
        <div className="fg" style={{marginTop:12}}><label>Email</label><input className="inp" type="email" value={form.email} onChange={e=>set("email",e.target.value)}/></div>
        <div className="frow">
          <div className="fg" style={{marginBottom:0}}><label>Phone</label><input className="inp" placeholder="+1 555 000 0000" value={form.phone} onChange={e=>set("phone",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:0}}><label>Username</label>
            <div style={{position:"relative"}}>
              <span style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)",fontSize:13,color:"#94a3b8",pointerEvents:"none"}}>@</span>
              <input className="inp" style={{paddingLeft:24}} value={form.username} onChange={e=>set("username",e.target.value.replace(/[^a-z0-9_.-]/gi,""))}/>
            </div>
          </div>
        </div>
        <div className="frow" style={{marginTop:12}}>
          <div className="fg" style={{marginBottom:0}}><label>Work Position</label><input className="inp" placeholder="e.g. Sales Lead" value={form.workPosition} onChange={e=>set("workPosition",e.target.value)}/></div>
          <div className="fg" style={{marginBottom:0}}><label>Job Title</label><input className="inp" placeholder="e.g. Sr. Account Executive" value={form.jobTitle} onChange={e=>set("jobTitle",e.target.value)}/></div>
        </div>
        <div className="fg" style={{marginTop:12}}><label>Company</label><input className="inp" placeholder="Company name" value={form.company} onChange={e=>set("company",e.target.value)}/></div>
        <div className="fg"><label>Address</label><input className="inp" placeholder="City, State / Country" value={form.address} onChange={e=>set("address",e.target.value)}/></div>
        <div className="fg">
          <label>Category</label>
          <select className="inp" value={form.category} onChange={e=>set("category",e.target.value)}>
            {CATEGORIES.map(c=><option key={c}>{c}</option>)}
          </select>
        </div>
        <div className="fg">
          <label>Bio</label>
          <textarea className="inp" placeholder="Short bio shown on the card…" value={form.bio}
            onChange={e=>set("bio",e.target.value)} style={{minHeight:80,resize:"vertical"}}/>
          <div style={{fontSize:10.5,color:"var(--t4)",marginTop:3,textAlign:"right"}}>{form.bio.length}/160</div>
        </div>
      </div>
  );

  if (apiPlatforms === null) {
    setApiPlatforms([]);
    api.getAvailablePlatforms().then(res => {
      const cats = res.data || res || [];
      const grouped = [];
      (Array.isArray(cats) ? cats : []).forEach(cat => {
        const items = (cat.platforms || []).map(p => ({
          id: p.id, type: p.title, label: p.title, ico: p.icon || null, color: '#64748b',
          platformId: p.id, baseUrl: p.baseURL || '', placeholder: p.placeholder || '', input: p.input || 'url',
          description: p.description || '',
        }));
        if (items.length > 0) grouped.push({ name: cat.name, platforms: items });
      });
      setApiPlatforms(grouped.length > 0 ? grouped : [{ name: "All", platforms: LINK_TYPES }]);
    }).catch(() => setApiPlatforms([{ name: "All", platforms: LINK_TYPES }]));
  }

  const SectionLinks = () => {
    const categories = apiPlatforms && apiPlatforms.length > 0 ? apiPlatforms : [{ name: "All", platforms: LINK_TYPES }];
    const searchVal = linkSearch.toLowerCase();
    const filteredCats = categories.map(cat => ({
      ...cat,
      platforms: cat.platforms.filter(lt =>
        (lt.label.toLowerCase().includes(searchVal) || lt.type.toLowerCase().includes(searchVal)) &&
        !form.links.find(l => l.type === lt.type)
      ),
    })).filter(cat => cat.platforms.length > 0);

    return (
      <div>
        <div className="ue-section-title">Links</div>
        <div className="ue-section-sub">Manage your profile links. Drag to reorder.</div>

        {/* ── + Add Platform button ── */}
        <button onClick={()=>setLinkPickerOpen(true)}
          style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,width:"100%",padding:"14px 20px",borderRadius:13,border:"2px dashed rgba(8,145,178,.3)",background:"rgba(8,145,178,.04)",cursor:"pointer",fontFamily:"var(--f)",fontSize:13.5,fontWeight:650,color:"#0891b2",transition:"all .18s",marginBottom:20}}
          onMouseEnter={e=>{e.currentTarget.style.background="rgba(8,145,178,.1)";e.currentTarget.style.borderColor="rgba(8,145,178,.5)";}}
          onMouseLeave={e=>{e.currentTarget.style.background="rgba(8,145,178,.04)";e.currentTarget.style.borderColor="rgba(8,145,178,.3)";}}>
          <span style={{fontSize:18}}>+</span> Add Platform
        </button>

        {/* ── Platform Picker Modal ── */}
        {linkPickerOpen && createPortal(
          <div style={{position:"fixed",inset:0,zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(15,23,42,.4)",backdropFilter:"blur(6px)"}}
            onClick={e=>{if(e.target===e.currentTarget){setLinkPickerOpen(false);setLinkSearch("");}}}>
            <div style={{width:"100%",maxWidth:680,maxHeight:"80vh",background:"rgba(255,255,255,.97)",backdropFilter:"blur(40px)",borderRadius:22,boxShadow:"0 32px 80px rgba(0,0,0,.18),0 8px 32px rgba(0,0,0,.1)",display:"flex",flexDirection:"column",overflow:"hidden",animation:"fadeIn .2s ease"}}>
              {/* Modal header */}
              <div style={{padding:"20px 24px 0",flexShrink:0}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
                  <div>
                    <div style={{fontSize:17,fontWeight:720,color:"#0f172a",letterSpacing:"-.3px"}}>Add Platform</div>
                    <div style={{fontSize:12,color:"#94a3b8",marginTop:2}}>Select a platform to add to your profile</div>
                  </div>
                  <button onClick={()=>{setLinkPickerOpen(false);setLinkSearch("");}}
                    style={{width:32,height:32,borderRadius:10,border:"1px solid rgba(0,0,0,.1)",background:"rgba(0,0,0,.04)",cursor:"pointer",fontSize:14,color:"#64748b",display:"flex",alignItems:"center",justifyContent:"center",transition:"all .14s"}}
                    onMouseEnter={e=>e.currentTarget.style.background="rgba(0,0,0,.08)"}
                    onMouseLeave={e=>e.currentTarget.style.background="rgba(0,0,0,.04)"}>✕</button>
                </div>
                <input className="inp" placeholder="🔍 Search platforms…" value={linkSearch} autoFocus
                  onChange={e=>setLinkSearch(e.target.value)} style={{marginBottom:16,fontSize:13}}/>
              </div>
              {/* Modal body — scrollable */}
              <div style={{flex:1,overflowY:"auto",padding:"0 24px 24px"}}>
                {filteredCats.map(cat => (
                  <div key={cat.name} style={{marginBottom:20}}>
                    <div style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:".08em",textTransform:"uppercase",marginBottom:10,padding:"0 2px"}}>{cat.name}</div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
                      {cat.platforms.map(lt => (
                        <button key={lt.type+lt.id} onClick={()=>{addLink(lt);setExpandedLink(Date.now());setLinkPickerOpen(false);setLinkSearch("");}}
                          style={{display:"flex",alignItems:"center",gap:8,padding:"12px 14px",borderRadius:12,border:"1.5px solid rgba(0,0,0,.08)",background:"rgba(255,255,255,.8)",cursor:"pointer",fontFamily:"var(--f)",transition:"all .16s",fontSize:13,fontWeight:600,color:"#334155"}}
                          onMouseEnter={e=>{e.currentTarget.style.background="#fff";e.currentTarget.style.borderColor="rgba(8,145,178,.4)";e.currentTarget.style.transform="translateY(-1px)";e.currentTarget.style.boxShadow="0 4px 14px rgba(0,0,0,.08)";}}
                          onMouseLeave={e=>{e.currentTarget.style.background="rgba(255,255,255,.8)";e.currentTarget.style.borderColor="rgba(0,0,0,.08)";e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="";}}>
                          {lt.ico && lt.ico.startsWith('http') ? (
                            <img src={lt.ico} alt="" style={{width:22,height:22,borderRadius:4,objectFit:"contain",flexShrink:0}}/>
                          ) : (
                            <span style={{fontSize:15}}>🔗</span>
                          )}
                          <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{lt.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
                {filteredCats.length===0&&<div style={{fontSize:13,color:"#94a3b8",padding:"32px 0",textAlign:"center"}}>No platforms found</div>}
              </div>
            </div>
          </div>,
          document.body
        )}

        {/* ── Added links ── */}
        {form.links.length>0&&(
          <div>
            <div style={{fontSize:10.5,fontWeight:700,color:"#94a3b8",letterSpacing:".1em",textTransform:"uppercase",marginBottom:9}}>Added Links ({form.links.length})</div>
            <div style={{display:"flex",flexDirection:"column",gap:7}}>
              {form.links.map((lk,i)=>{
                const isExp = expandedLink===lk.id;
                return (
                  <div key={lk.id} style={{borderRadius:14,border:`1.5px solid ${isExp?lk.color+"44":"rgba(0,0,0,.08)"}`,overflow:"hidden",background:isExp?"rgba(255,255,255,.96)":"rgba(255,255,255,.72)",transition:"all .18s",boxShadow:isExp?`0 4px 20px ${lk.color}18`:"none"}}>
                    <div style={{display:"flex",alignItems:"center",gap:11,padding:"10px 14px",cursor:"pointer"}} onClick={()=>setExpandedLink(isExp?null:lk.id)}>
                      <div style={{fontSize:9,color:"#cbd5e1",cursor:"grab",userSelect:"none"}}>⠿⠿</div>
                      <div style={{width:34,height:34,borderRadius:10,background:lk.color+"14",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,flexShrink:0}}>
                        {lk.ico && lk.ico.startsWith('http') ? <img src={lk.ico} alt="" style={{width:20,height:20,borderRadius:4,objectFit:"contain"}}/> : (lk.ico || '🔗')}
                      </div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:12.5,fontWeight:660,color:"#0f172a"}}>{lk.label}</div>
                        <div style={{fontSize:11,color:"#94a3b8",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{lk.url||"No URL set"}</div>
                      </div>
                      <div style={{display:"flex",gap:5,flexShrink:0}}>
                        <button onClick={e=>{e.stopPropagation();moveLink(i,-1);}} style={{width:22,height:22,border:"1px solid rgba(0,0,0,.1)",borderRadius:6,background:"rgba(255,255,255,.8)",cursor:"pointer",fontSize:11,color:"#64748b"}}>↑</button>
                        <button onClick={e=>{e.stopPropagation();moveLink(i,1);}} style={{width:22,height:22,border:"1px solid rgba(0,0,0,.1)",borderRadius:6,background:"rgba(255,255,255,.8)",cursor:"pointer",fontSize:11,color:"#64748b"}}>↓</button>
                        <button onClick={e=>{e.stopPropagation();removeLink(lk.id);}} style={{width:22,height:22,border:"1px solid rgba(220,38,38,.18)",borderRadius:6,background:"rgba(220,38,38,.06)",cursor:"pointer",fontSize:12,color:"#dc2626",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                      </div>
                      <div style={{fontSize:13,color:"#94a3b8",transition:"transform .2s",transform:isExp?"rotate(90deg)":"rotate(0deg)"}}>›</div>
                    </div>
                    {isExp&&(
                      <div style={{padding:"10px 14px 14px",borderTop:`1px solid ${lk.color}22`,background:`${lk.color}04`}}>
                        {/* Description / instruction */}
                        {lk.description&&<div style={{fontSize:11,color:"#64748b",marginBottom:10,padding:"8px 10px",background:"rgba(100,116,139,.06)",borderRadius:8,lineHeight:1.5}}>💡 {lk.description}</div>}

                        <div className="fg" style={{marginBottom:8}}>
                          <label>Display Label</label>
                          <input className="inp" value={lk.label} onChange={e=>updateLink(lk.id,"label",e.target.value)} style={{fontSize:12}}/>
                        </div>

                        {/* Input based on type */}
                        {lk.input==="username"&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>Username</label>
                            <div style={{display:"flex",gap:0}}>
                              {lk.baseUrl&&<div style={{padding:"9px 12px",background:"rgba(0,0,0,.05)",border:"1px solid rgba(0,0,0,.1)",borderRight:"none",borderRadius:"10px 0 0 10px",fontSize:12,color:"#94a3b8",whiteSpace:"nowrap",display:"flex",alignItems:"center"}}>{lk.baseUrl}</div>}
                              <input className="inp" placeholder={lk.placeholder||"Username"} value={lk.url} onChange={e=>updateLink(lk.id,"url",e.target.value.replace(/[^a-zA-Z0-9._-]/g,""))} style={{fontSize:12,borderRadius:lk.baseUrl?"0 10px 10px 0":"10px"}}/>
                            </div>
                          </div>
                        )}
                        {lk.input==="url"&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>URL</label>
                            <input className="inp" type="url" placeholder={lk.placeholder||"https://…"} value={lk.url} onChange={e=>updateLink(lk.id,"url",e.target.value)} style={{fontSize:12}}/>
                          </div>
                        )}
                        {lk.input==="video_url"&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>Video URL</label>
                            <input className="inp" type="url" placeholder={lk.placeholder||"https://…"} value={lk.url} onChange={e=>updateLink(lk.id,"url",e.target.value)} style={{fontSize:12}}/>
                          </div>
                        )}
                        {lk.input==="email"&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>Email Address</label>
                            <input className="inp" type="email" placeholder={lk.placeholder||"email@example.com"} value={lk.url} onChange={e=>updateLink(lk.id,"url",e.target.value)} style={{fontSize:12}}/>
                          </div>
                        )}
                        {lk.input==="phone"&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>Phone Number</label>
                            <input className="inp" type="tel" placeholder={lk.placeholder||"+1 555 000 0000"} value={lk.url} onChange={e=>updateLink(lk.id,"url",e.target.value.replace(/[^+\d\s()-]/g,""))} style={{fontSize:12}}/>
                          </div>
                        )}
                        {lk.input==="document"&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>Document (PDF, DOC, DOCX)</label>
                            {lk.url&&<div style={{fontSize:11,color:"#059669",marginBottom:6}}>Current: {lk.url.split('/').pop()}</div>}
                            <input type="file" accept=".pdf,.doc,.docx" onChange={e=>{
                              const f=e.target.files[0]; if(!f) return;
                              updateLink(lk.id,"docFile",f);
                              updateLink(lk.id,"url",f.name);
                            }} style={{fontSize:12}}/>
                          </div>
                        )}
                        {lk.input==="other"&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>Value</label>
                            <input className="inp" placeholder={lk.placeholder||"Enter value…"} value={lk.url} onChange={e=>updateLink(lk.id,"url",e.target.value)} style={{fontSize:12}}/>
                          </div>
                        )}
                        {!["username","url","video_url","email","phone","document","other"].includes(lk.input)&&(
                          <div className="fg" style={{marginBottom:0}}>
                            <label>Value</label>
                            <input className="inp" placeholder={lk.placeholder||"Enter value…"} value={lk.url} onChange={e=>updateLink(lk.id,"url",e.target.value)} style={{fontSize:12}}/>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {form.links.length===0&&(
          <div style={{textAlign:"center",padding:"48px 0",color:"#94a3b8"}}>
            <div style={{fontSize:40,marginBottom:10}}>🔗</div>
            <div style={{fontSize:14,fontWeight:600,color:"#64748b"}}>No links added yet</div>
            <div style={{fontSize:12,marginTop:6}}>Click "+ Add Platform" to get started</div>
          </div>
        )}
      </div>
    );
  };

  const SectionCapture = () => (
    <div>
      <div className="ue-section-title">Lead Capture Form</div>
      <div className="ue-section-sub">Collect visitor info — preview updates live in the card →</div>

      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 18px",background:"rgba(255,255,255,.72)",border:"1px solid rgba(0,0,0,.08)",borderRadius:13,marginBottom:18}}>
        <div>
          <div style={{fontSize:13,fontWeight:640,color:"var(--t1)"}}>Lead Capture</div>
          <div style={{fontSize:11.5,color:"var(--t3)",marginTop:2}}>
            {form.captureEnabled ? "✅ Enabled — visitors must fill the form" : "⬜ Disabled — profile is open to all"}
          </div>
        </div>
        <Toggle on={form.captureEnabled} onChange={()=>set("captureEnabled",!form.captureEnabled)}/>
      </div>

      {form.captureEnabled&&(
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14,padding:"9px 13px",background:"rgba(8,145,178,.06)",border:"1px solid rgba(8,145,178,.18)",borderRadius:10}}>
          <div style={{fontSize:12,color:"#0891b2",fontWeight:600}}>👁 Form preview showing in card →</div>
          <button onClick={()=>setShowCaptureForm(v=>!v)}
            style={{fontSize:11.5,padding:"4px 12px",borderRadius:8,border:"1px solid rgba(8,145,178,.3)",background:showCaptureForm?"#0891b2":"transparent",color:showCaptureForm?"white":"#0891b2",cursor:"pointer",fontFamily:"var(--f)",fontWeight:600,transition:"all .15s"}}>
            {showCaptureForm?"Hide preview":"Show preview"}
          </button>
        </div>
      )}

      {form.captureEnabled && (
        <>
          {/* Mandatory fields */}
          <div style={{fontSize:11,fontWeight:700,color:"var(--t3)",letterSpacing:".09em",textTransform:"uppercase",marginBottom:10}}>Mandatory Fields</div>
          {form.captureFields.filter(f=>f.required).map((f,i)=>(
            <div key={f.key} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px",background:f.on?"rgba(255,255,255,.72)":"rgba(0,0,0,.02)",border:"1px solid rgba(0,0,0,.06)",borderRadius:12,marginBottom:8,transition:"all .15s"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:18}}>{f.ico}</span>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>{f.label}</div>
                  <div style={{fontSize:10.5,color:"#059669",fontWeight:550}}>Required</div>
                </div>
              </div>
              <Toggle on={f.on} onChange={()=>{
                const arr=[...form.captureFields];
                const idx=arr.findIndex(x=>x.key===f.key);
                arr[idx]={...arr[idx],on:!arr[idx].on};
                set("captureFields",arr);
              }}/>
            </div>
          ))}

          {/* Optional fields */}
          <div style={{fontSize:11,fontWeight:700,color:"var(--t3)",letterSpacing:".09em",textTransform:"uppercase",marginBottom:10,marginTop:20}}>Optional Fields</div>
          {form.captureFields.filter(f=>!f.required).map((f)=>(
            <div key={f.key} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 16px",background:f.on?"rgba(255,255,255,.72)":"rgba(0,0,0,.02)",border:"1px solid rgba(0,0,0,.06)",borderRadius:12,marginBottom:8,transition:"all .15s"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:18}}>{f.ico}</span>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>{f.label}</div>
                  <div style={{fontSize:10.5,color:"var(--t3)"}}>Optional</div>
                </div>
              </div>
              <Toggle on={f.on} onChange={()=>{
                const arr=[...form.captureFields];
                const idx=arr.findIndex(x=>x.key===f.key);
                arr[idx]={...arr[idx],on:!arr[idx].on};
                set("captureFields",arr);
              }}/>
            </div>
          ))}

          <div style={{marginTop:14,padding:"12px 16px",background:"rgba(100,116,139,.05)",borderRadius:10,display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:18}}>📊</span>
            <div>
              <div style={{fontSize:12,fontWeight:600,color:"var(--t1)"}}>{form.captureFields.filter(f=>f.on).length} fields active</div>
              <div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>These fields will be shown on the lead capture form when someone taps your card.</div>
            </div>
          </div>
        </>
      )}
    </div>
  );

  const qrCanvasRef = useRef(null);
  const profileUrl = `https://gotaps.me/${form.username || member.username || ''}`;
  const logoUrl = process.env.PUBLIC_URL + '/favicon.png';

  // QR data URL used by the Virtual Background tab (corner watermark).
  // Regenerates whenever the profile URL or QR colors change so the preview
  // and the exported PNG stay in sync with the QR Code tab settings.
  const [vbgQrDataUrl, setVbgQrDataUrl] = useState('');
  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(profileUrl, {
      width: 240, margin: 1,
      color: { dark: form.qrColor, light: form.qrBg },
      errorCorrectionLevel: 'M',
    }).then((url) => { if (!cancelled) setVbgQrDataUrl(url); }).catch(() => {});
    return () => { cancelled = true; };
  }, [profileUrl, form.qrColor, form.qrBg]);

  const renderQR = useCallback(() => {
    const canvas = qrCanvasRef.current;
    if (!canvas) return;
    QRCode.toCanvas(canvas, profileUrl, {
      width: 280,
      margin: 2,
      color: { dark: form.qrColor, light: form.qrBg },
      errorCorrectionLevel: 'H',
    }, (err) => {
      if (err) return;
      // Draw logo in center
      const ctx = canvas.getContext('2d');
      const logo = new Image();
      logo.crossOrigin = 'anonymous';
      logo.onload = () => {
        const logoSize = canvas.width * 0.22;
        const x = (canvas.width - logoSize) / 2;
        const y = (canvas.height - logoSize) / 2;
        // White circle background
        ctx.beginPath();
        ctx.arc(x + logoSize/2, y + logoSize/2, logoSize/2 + 4, 0, Math.PI * 2);
        ctx.fillStyle = form.qrBg;
        ctx.fill();
        // Draw logo
        ctx.drawImage(logo, x, y, logoSize, logoSize);
      };
      logo.src = logoUrl;
    });
  }, [profileUrl, form.qrColor, form.qrBg]);

  const SectionQR = () => {
    // Trigger QR render when deps change - using a timeout to avoid hook issues
    setTimeout(renderQR, 50);

    const downloadPNG = () => {
      const canvas = qrCanvasRef.current;
      if (!canvas) return;
      const dataUrl = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = `qr_${form.username || 'gotaps'}.png`;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      onToast("QR Code downloaded as PNG!");
    };

    const copySVG = async () => {
      try {
        const svgStr = await QRCode.toString(profileUrl, {
          type: 'svg',
          width: 400,
          margin: 2,
          color: { dark: form.qrColor, light: form.qrBg },
          errorCorrectionLevel: 'H',
        });
        await navigator.clipboard?.writeText(svgStr);
        onToast("SVG copied to clipboard!");
      } catch { onToast("Failed to copy SVG", "error"); }
    };

    return (
      <div>
        <div className="ue-section-title">QR Code Sharing</div>
        <div className="ue-section-sub">Scan to open <b>{profileUrl}</b></div>

        {/* QR Preview */}
        <div style={{display:"flex",justifyContent:"center",marginBottom:22}}>
          <div style={{background:form.qrBg,borderRadius:18,padding:20,boxShadow:"0 8px 32px rgba(0,0,0,.12)",border:"1px solid rgba(0,0,0,.08)",display:"flex",flexDirection:"column",alignItems:"center",gap:10}}>
            <canvas ref={qrCanvasRef} style={{borderRadius:8,width:220,height:220}}/>
            <div style={{fontSize:10,color:form.qrColor,fontWeight:600,letterSpacing:".02em",opacity:.6}}>gotaps.me/{form.username||'—'}</div>
          </div>
        </div>

        {/* Profile URL */}
        <div className="fg">
          <label>Profile URL</label>
          <div style={{display:"flex",gap:8}}>
            <input className="inp" value={profileUrl} readOnly style={{flex:1,fontSize:12,color:"#64748b"}}/>
            <button className="btn bs" style={{padding:"0 14px",fontSize:12,flexShrink:0}} onClick={()=>{navigator.clipboard?.writeText(profileUrl);onToast("Profile URL copied!");}}>⧉ Copy</button>
          </div>
        </div>

        {/* Color pickers */}
        <div className="frow" style={{marginTop:12}}>
          <div className="fg" style={{marginBottom:0}}>
            <label>QR Color</label>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <input type="color" value={form.qrColor} onChange={e=>set("qrColor",e.target.value)} style={{width:38,height:38,borderRadius:8,border:"1px solid rgba(0,0,0,.1)",cursor:"pointer",padding:2}}/>
              <input className="inp" value={form.qrColor} onChange={e=>set("qrColor",e.target.value)} style={{flex:1,fontSize:12}}/>
            </div>
          </div>
          <div className="fg" style={{marginBottom:0}}>
            <label>Background</label>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <input type="color" value={form.qrBg} onChange={e=>set("qrBg",e.target.value)} style={{width:38,height:38,borderRadius:8,border:"1px solid rgba(0,0,0,.1)",cursor:"pointer",padding:2}}/>
              <input className="inp" value={form.qrBg} onChange={e=>set("qrBg",e.target.value)} style={{flex:1,fontSize:12}}/>
            </div>
          </div>
        </div>

        {/* Download / Copy buttons */}
        <div style={{display:"flex",gap:9,marginTop:18}}>
          <button className="btn bp" style={{flex:1,justifyContent:"center",gap:6}} onClick={downloadPNG}>⬇ Download PNG</button>
          <button className="btn bs" style={{flex:1,justifyContent:"center",gap:6}} onClick={copySVG}>⧉ Copy SVG</button>
        </div>

        {/* Quick presets */}
        <div className="fg" style={{marginTop:16}}>
          <label>Quick Presets</label>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {[
              {label:"Classic",fg:"#000000",bg:"#ffffff"},
              {label:"Dark",fg:"#ffffff",bg:"#0f172a"},
              {label:"Brand",fg:"#64748b",bg:"#f8fafc"},
              {label:"Teal",fg:"#0891b2",bg:"#f0fdfa"},
              {label:"Purple",fg:"#7c3aed",bg:"#faf5ff"},
              {label:"Red",fg:"#dc2626",bg:"#fef2f2"},
            ].map(p=>(
              <button key={p.label} onClick={()=>{set("qrColor",p.fg);set("qrBg",p.bg);}}
                style={{padding:"8px 14px",borderRadius:10,border:"1px solid rgba(0,0,0,.08)",background:"rgba(255,255,255,.8)",cursor:"pointer",fontFamily:"var(--f)",fontSize:12,fontWeight:600,color:"#334155",display:"flex",alignItems:"center",gap:6,transition:"all .14s"}}
                onMouseEnter={e=>e.currentTarget.style.transform="translateY(-1px)"}
                onMouseLeave={e=>e.currentTarget.style.transform=""}>
                <div style={{width:14,height:14,borderRadius:4,background:p.fg,border:"1px solid rgba(0,0,0,.1)"}}/>
                <div style={{width:14,height:14,borderRadius:4,background:p.bg,border:"1px solid rgba(0,0,0,.1)"}}/>
                {p.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const vbgCanvasRef = useRef(null);
  const vbgImgRef = useRef(null);

  const getVbgBackground = () => {
    if (form.vbgMode === "image" && form.vbgImg) return null; // image handled separately
    if (form.vbgMode === "solid") return form.vbgColor1;
    return `linear-gradient(${form.vbgAngle || 135}deg,${form.vbgColor1},${form.vbgColor2})`;
  };

  const renderVbgCanvas = (download) => {
    const canvas = document.createElement('canvas');
    canvas.width = 1920; canvas.height = 1080;
    const ctx = canvas.getContext('2d');

    const exportCanvas = () => {
      if (download) {
        const dataUrl = canvas.toDataURL('image/png');
        const a = document.createElement('a');
        a.href = dataUrl;
        a.download = `vbg_${form.username || 'gotaps'}.png`;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        onToast("Virtual background downloaded (1920×1080)!");
      } else {
        canvas.toBlob(async (blob) => {
          try {
            await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
            onToast("Background copied to clipboard!");
          } catch { onToast("Copy failed — try downloading instead", "error"); }
        }, 'image/png');
      }
    };

    const drawQrThenExport = () => {
      // QR top-right — matches the live preview placement and the QR Code tab settings.
      QRCode.toDataURL(profileUrl, {
        width: 220, margin: 1,
        color: { dark: form.qrColor, light: form.qrBg },
        errorCorrectionLevel: 'M',
      }).then((qrUrl) => {
        const qr = new Image();
        qr.onload = () => {
          const qrSize = 220;
          const pad = 14;
          const cardW = qrSize + pad * 2;
          const cardX = 1920 - cardW - 40; // 40px from right edge
          const cardY = 30;                 // 30px from top edge
          ctx.fillStyle = form.qrBg;
          ctx.beginPath();
          if (ctx.roundRect) {
            ctx.roundRect(cardX, cardY, cardW, cardW, 18);
          } else {
            ctx.rect(cardX, cardY, cardW, cardW);
          }
          ctx.fill();
          ctx.drawImage(qr, cardX + pad, cardY + pad, qrSize, qrSize);
          exportCanvas();
        };
        qr.onerror = exportCanvas; // QR failed → still export the rest
        qr.src = qrUrl;
      }).catch(exportCanvas);
    };

    const drawOverlay = () => {
      const logo = new Image();
      logo.crossOrigin = 'anonymous';
      logo.onload = () => {
        // Logo top-left
        ctx.drawImage(logo, 40, 30, 48, 48);
        ctx.fillStyle = '#fff'; ctx.font = 'bold 28px sans-serif'; ctx.textBaseline = 'middle';
        ctx.fillText('GOtaps', 100, 46);
        ctx.fillStyle = 'rgba(255,255,255,.6)'; ctx.font = '600 12px sans-serif';
        ctx.fillText('ENTERPRISE', 100, 68);

        // Name card bottom-left
        ctx.fillStyle = 'rgba(255,255,255,.15)';
        ctx.beginPath(); ctx.roundRect(40, 960, 400, 80, 16); ctx.fill();
        ctx.fillStyle = '#fff'; ctx.font = 'bold 26px sans-serif'; ctx.textBaseline = 'alphabetic';
        ctx.fillText(`${form.firstName} ${form.lastName}`, 60, 995);
        ctx.fillStyle = 'rgba(255,255,255,.8)'; ctx.font = '500 16px sans-serif';
        ctx.fillText(`${form.workPosition || ''} · ${form.company || ''}`, 60, 1025);

        // URL bottom-right
        ctx.fillStyle = 'rgba(255,255,255,.4)'; ctx.font = '500 14px sans-serif';
        ctx.textAlign = 'right';
        ctx.fillText('gotaps.me', 1880, 1060);
        ctx.textAlign = 'left';

        drawQrThenExport();
      };
      logo.onerror = () => {
        // Fallback without logo
        ctx.fillStyle = '#fff'; ctx.font = 'bold 28px sans-serif'; ctx.textBaseline = 'middle';
        ctx.fillText('GOtaps', 40, 55);
        drawQrThenExport();
      };
      logo.src = process.env.PUBLIC_URL + '/favicon.png';
    };

    if (form.vbgMode === "image" && form.vbgImg) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => { ctx.drawImage(img, 0, 0, 1920, 1080); drawOverlay(); };
      img.src = form.vbgImg;
    } else if (form.vbgMode === "solid") {
      ctx.fillStyle = form.vbgColor1;
      ctx.fillRect(0, 0, 1920, 1080);
      drawOverlay();
    } else {
      // Gradient
      const angle = (form.vbgAngle || 135) * Math.PI / 180;
      const x1 = 960 - Math.cos(angle) * 1200, y1 = 540 - Math.sin(angle) * 1200;
      const x2 = 960 + Math.cos(angle) * 1200, y2 = 540 + Math.sin(angle) * 1200;
      const grad = ctx.createLinearGradient(x1, y1, x2, y2);
      grad.addColorStop(0, form.vbgColor1);
      grad.addColorStop(1, form.vbgColor2);
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, 1920, 1080);
      drawOverlay();
    }
  };

  const SectionVBG = () => (
    <div>
      <div className="ue-section-title">Virtual Background</div>
      <div className="ue-section-sub">Branded background for Zoom, Google Meet and Teams · 1920×1080</div>

      {/* Live Preview */}
      <div style={{position:"relative",aspectRatio:"16/9",borderRadius:16,overflow:"hidden",marginBottom:20,boxShadow:"0 8px 32px rgba(0,0,0,.15)",border:"1px solid rgba(0,0,0,.08)"}}>
        <div style={{position:"absolute",inset:0,
          background: form.vbgMode==="image" && form.vbgImg
            ? `url(${form.vbgImg}) center/cover`
            : form.vbgMode==="solid" ? form.vbgColor1
            : `linear-gradient(${form.vbgAngle||135}deg,${form.vbgColor1},${form.vbgColor2})`
        }}/>
        {/* Logo */}
        <div style={{position:"absolute",top:14,left:16,display:"flex",alignItems:"center",gap:8}}>
          <img src={process.env.PUBLIC_URL+'/favicon.png'} alt="" style={{width:28,height:28,borderRadius:7}}/>
          <div><div style={{fontSize:13,fontWeight:780,color:"#fff",textShadow:"0 1px 4px rgba(0,0,0,.3)"}}>GOtaps</div><div style={{fontSize:8,color:"rgba(255,255,255,.6)",fontWeight:600,letterSpacing:".06em"}}>ENTERPRISE</div></div>
        </div>
        {/* QR top-right — mirrors the QR Code tab settings (qrColor / qrBg) */}
        {vbgQrDataUrl && (
          <div style={{
            position:"absolute", top:14, right:16,
            background:form.qrBg, padding:6, borderRadius:10,
            boxShadow:"0 4px 14px rgba(0,0,0,.18)",
            width:74, height:74,
            display:"flex", alignItems:"center", justifyContent:"center",
          }}>
            <img src={vbgQrDataUrl} alt="QR" style={{width:"100%",height:"100%",display:"block"}}/>
          </div>
        )}
        {/* Name card */}
        <div style={{position:"absolute",bottom:14,left:16,background:"rgba(255,255,255,.12)",backdropFilter:"blur(20px)",borderRadius:10,padding:"8px 14px",border:"1px solid rgba(255,255,255,.2)"}}>
          <div style={{fontSize:14,fontWeight:780,color:"#fff",textShadow:"0 1px 4px rgba(0,0,0,.2)"}}>{form.firstName} {form.lastName}</div>
          <div style={{fontSize:10,color:"rgba(255,255,255,.75)",marginTop:2}}>{form.workPosition||''} · {form.company||''}</div>
        </div>
        <div style={{position:"absolute",bottom:12,right:14,fontSize:9,color:"rgba(255,255,255,.4)",fontWeight:600}}>gotaps.me</div>
      </div>

      {/* Mode tabs: Solid | Gradient | Image */}
      <div style={{display:"flex",gap:4,background:"rgba(0,0,0,.04)",padding:4,borderRadius:11,marginBottom:16}}>
        {[["solid","🎨 Solid"],["color","🌈 Gradient"],["image","🖼️ Image"]].map(([m,l])=>(
          <button key={m} onClick={()=>set("vbgMode",m)}
            style={{flex:1,padding:"9px",border:"none",borderRadius:8,cursor:"pointer",fontSize:12.5,fontWeight:620,fontFamily:"var(--f)",transition:"all .18s",
              background:form.vbgMode===m?"rgba(255,255,255,.96)":"transparent",
              color:form.vbgMode===m?"#0f172a":"#64748b",
              boxShadow:form.vbgMode===m?"0 2px 10px rgba(0,0,0,.08)":"none"}}>{l}</button>
        ))}
      </div>

      {/* Solid Color */}
      {form.vbgMode==="solid"&&(
        <>
          <div className="fg">
            <label>Background Color</label>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <input type="color" value={form.vbgColor1} onChange={e=>set("vbgColor1",e.target.value)} style={{width:42,height:42,borderRadius:10,border:"1px solid rgba(0,0,0,.1)",cursor:"pointer",padding:2}}/>
              <input className="inp" value={form.vbgColor1} onChange={e=>set("vbgColor1",e.target.value)} style={{flex:1,fontSize:12}}/>
            </div>
          </div>
          <div className="fg"><label>Solid Presets</label>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {["#0f172a","#1e293b","#0c4a6e","#064e3b","#1e1b4b","#78350f","#7f1d1d","#18181b","#f8fafc","#e2e8f0"].map(c=>(
                <div key={c} onClick={()=>set("vbgColor1",c)}
                  style={{width:38,height:38,borderRadius:10,background:c,cursor:"pointer",transition:"all .15s",
                    border:form.vbgColor1===c?"2.5px solid #0891b2":"2.5px solid transparent",
                    boxShadow:form.vbgColor1===c?"0 0 0 3px rgba(8,145,178,.2)":"0 2px 8px rgba(0,0,0,.1)"}}/>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Gradient */}
      {form.vbgMode==="color"&&(
        <>
          <div className="frow">
            <div className="fg" style={{marginBottom:0}}><label>Color 1</label><div style={{display:"flex",alignItems:"center",gap:8}}><input type="color" value={form.vbgColor1} onChange={e=>set("vbgColor1",e.target.value)} style={{width:38,height:38,borderRadius:8,border:"1px solid rgba(0,0,0,.1)",cursor:"pointer",padding:2}}/><input className="inp" value={form.vbgColor1} onChange={e=>set("vbgColor1",e.target.value)} style={{flex:1,fontSize:12}}/></div></div>
            <div className="fg" style={{marginBottom:0}}><label>Color 2</label><div style={{display:"flex",alignItems:"center",gap:8}}><input type="color" value={form.vbgColor2} onChange={e=>set("vbgColor2",e.target.value)} style={{width:38,height:38,borderRadius:8,border:"1px solid rgba(0,0,0,.1)",cursor:"pointer",padding:2}}/><input className="inp" value={form.vbgColor2} onChange={e=>set("vbgColor2",e.target.value)} style={{flex:1,fontSize:12}}/></div></div>
          </div>
          <div className="fg" style={{marginTop:12}}>
            <label>Angle: {form.vbgAngle || 135}°</label>
            <input type="range" min="0" max="360" value={form.vbgAngle||135} onChange={e=>set("vbgAngle",Number(e.target.value))} style={{width:"100%",accentColor:"#0891b2"}}/>
          </div>
          <div className="fg" style={{marginTop:8}}><label>Gradient Presets</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
              {[
                {c1:"#0c4a6e",c2:"#0891b2",l:"Ocean"},{c1:"#064e3b",c2:"#059669",l:"Forest"},
                {c1:"#1e1b4b",c2:"#7c3aed",l:"Purple"},{c1:"#78350f",c2:"#d97706",l:"Amber"},
                {c1:"#1e293b",c2:"#64748b",l:"Slate"},{c1:"#7f1d1d",c2:"#dc2626",l:"Red"},
                {c1:"#1a1a2e",c2:"#e94560",l:"Neon"},{c1:"#0f3460",c2:"#533483",l:"Cosmic"},
                {c1:"#0d9488",c2:"#06b6d4",l:"Teal"},{c1:"#9333ea",c2:"#ec4899",l:"Vivid"},
                {c1:"#1e3a5f",c2:"#4a90d9",l:"Sky"},{c1:"#2d1b69",c2:"#11998e",l:"Aurora"},
              ].map(p=>(
                <div key={p.l} onClick={()=>{set("vbgColor1",p.c1);set("vbgColor2",p.c2);}}
                  style={{aspectRatio:"16/9",borderRadius:10,background:`linear-gradient(135deg,${p.c1},${p.c2})`,cursor:"pointer",transition:"all .15s",display:"flex",alignItems:"flex-end",justifyContent:"center",paddingBottom:6,
                    border:(form.vbgColor1===p.c1&&form.vbgColor2===p.c2)?"2.5px solid #fff":"2.5px solid transparent",
                    boxShadow:(form.vbgColor1===p.c1&&form.vbgColor2===p.c2)?"0 0 0 3px rgba(0,0,0,.2),0 4px 14px rgba(0,0,0,.15)":"0 2px 8px rgba(0,0,0,.1)"}}>
                  <span style={{fontSize:9.5,fontWeight:700,color:"rgba(255,255,255,.8)",textShadow:"0 1px 3px rgba(0,0,0,.3)"}}>{p.l}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Image */}
      {form.vbgMode==="image"&&(
        <div>
          <div style={{marginBottom:14}}>
            <label>Upload Custom Background</label>
            <div onClick={()=>vbgImgRef.current?.click()}
              style={{height:56,borderRadius:12,border:"2px dashed rgba(100,116,139,.3)",background:"rgba(255,255,255,.65)",display:"flex",alignItems:"center",justifyContent:"center",gap:9,cursor:"pointer",transition:"all .16s",fontSize:13,color:"#64748b",fontWeight:600}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor="rgba(8,145,178,.5)";e.currentTarget.style.background="rgba(8,145,178,.04)";}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor="rgba(100,116,139,.3)";e.currentTarget.style.background="rgba(255,255,255,.65)";}}>
              <span style={{fontSize:22}}>🖼️</span> Upload image (JPG, PNG, WEBP)
            </div>
            <input ref={vbgImgRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
              const f=e.target.files[0]; if(!f) return;
              const r=new FileReader(); r.onload=ev=>{set("vbgImg",ev.target.result);set("vbgMode","image");}; r.readAsDataURL(f);
            }}/>
            {form.vbgImg&&<div style={{display:"flex",gap:8,alignItems:"center",marginTop:8}}>
              <span style={{fontSize:12,color:"#059669",fontWeight:600}}>✓ Custom image uploaded</span>
              <button onClick={()=>set("vbgImg",null)} style={{fontSize:11,padding:"3px 10px",borderRadius:7,border:"1px solid rgba(220,38,38,.2)",background:"rgba(220,38,38,.07)",color:"#dc2626",cursor:"pointer",fontFamily:"var(--f)"}}>Remove</button>
            </div>}
          </div>
          <div><label>Stock Backgrounds</label>
            <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:8}}>
              {VBG_IMAGES.map((img,i)=>(
                <div key={i} onClick={()=>{set("vbgImg",img);set("vbgMode","image");}}
                  style={{aspectRatio:"16/9",borderRadius:10,overflow:"hidden",cursor:"pointer",transition:"all .16s",
                    border:form.vbgImg===img?"2.5px solid #0891b2":"2.5px solid transparent",
                    boxShadow:form.vbgImg===img?"0 0 0 3px rgba(8,145,178,.2)":"0 2px 8px rgba(0,0,0,.08)",
                    background:`url(${img}) center/cover`,position:"relative"}}>
                  {form.vbgImg===img&&<div style={{position:"absolute",inset:0,background:"rgba(8,145,178,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,color:"#fff"}}>✓</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Action buttons */}
      <div style={{display:"flex",gap:9,marginTop:18}}>
        <button className="btn bp" style={{flex:1,justifyContent:"center",gap:6}} onClick={()=>renderVbgCanvas(true)}>⬇ Download PNG</button>
        <button className="btn bs" style={{flex:1,justifyContent:"center",gap:6}} onClick={()=>renderVbgCanvas(false)}>⧉ Copy to Clipboard</button>
      </div>

      <div style={{marginTop:12,padding:"10px 14px",background:"rgba(100,116,139,.05)",borderRadius:10,fontSize:11.5,color:"#64748b",display:"flex",alignItems:"center",gap:8}}>
        <span style={{fontSize:16}}>💡</span>
        Use this as your background in Zoom, Google Meet, or Microsoft Teams for a branded look.
      </div>
    </div>
  );

  const sigPreviewRef = useRef(null);
  const SectionSignature = () => {
    const acc = SIG_TEMPLATES.find(t=>t.id===form.sigTemplate)?.accent || "#0891b2";
    const SigPreview = ({id}) => {
      if(id==="modern") return (
        <div style={{display:"flex",alignItems:"center",gap:14,fontFamily:"Arial,sans-serif"}}>
          <div style={{borderRight:`3px solid ${acc}`,paddingRight:14,flexShrink:0}}>
            {form.avatarImg
              ? <div style={{width:50,height:50,borderRadius:"50%",overflow:"hidden"}}><img src={form.avatarImg} style={{width:"100%",height:"100%",objectFit:"cover"}}/></div>
              : <div style={{width:50,height:50,borderRadius:"50%",background:form.grad,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:17,color:"#fff"}}>{form.av}</div>}
          </div>
          <div>
            <div style={{fontSize:14.5,fontWeight:700,color:"#0f172a"}}>{form.firstName} {form.lastName}</div>
            <div style={{fontSize:11.5,color:"#64748b",marginTop:1}}>{form.jobTitle} · {form.company}</div>
            <div style={{fontSize:11,color:"#94a3b8",marginTop:3}}>{form.email} {form.phone?"· "+form.phone:""}</div>
            <div style={{marginTop:6,display:"flex",gap:6,flexWrap:"wrap"}}>
              {form.links.filter(l=>["linkedin","twitter","instagram"].includes(l.type)).map(l=>(
                <span key={l.id} style={{fontSize:10.5,fontWeight:700,color:l.color}}>{l.label}</span>
              ))}
            </div>
            <div style={{marginTop:5,fontSize:9.5,color:"#94a3b8"}}>Powered by Gotaps ✦</div>
          </div>
        </div>
      );
      if(id==="minimal") return (
        <div style={{fontFamily:"Arial,sans-serif",borderTop:`2px solid ${acc}`,paddingTop:10}}>
          <div style={{fontSize:14,fontWeight:700,color:"#0f172a"}}>{form.firstName} {form.lastName}</div>
          <div style={{fontSize:11.5,color:"#64748b",marginTop:1}}>{form.jobTitle} · {form.company}</div>
          <div style={{display:"flex",gap:10,marginTop:6,fontSize:11,color:"#94a3b8"}}>
            <span>{form.email}</span>{form.phone&&<span>{form.phone}</span>}
          </div>
        </div>
      );
      if(id==="classic") return (
        <div style={{display:"flex",gap:16,fontFamily:"Georgia,serif",borderLeft:`4px solid ${acc}`,paddingLeft:14}}>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:"#0f172a",letterSpacing:"-.2px"}}>{form.firstName} {form.lastName}</div>
            <div style={{fontSize:11.5,color:acc,fontStyle:"italic",marginTop:1}}>{form.jobTitle}</div>
            <div style={{fontSize:11,color:"#64748b",marginTop:4}}>{form.company}</div>
            <div style={{fontSize:11,color:"#94a3b8",marginTop:3}}>{form.email}</div>
          </div>
        </div>
      );
      if(id==="bold") return (
        <div style={{fontFamily:"Arial,sans-serif",background:`linear-gradient(135deg,${acc}12,transparent)`,borderRadius:10,padding:"12px 14px"}}>
          <div style={{fontSize:16,fontWeight:800,color:acc,letterSpacing:"-.4px"}}>{form.firstName} {form.lastName}</div>
          <div style={{fontSize:12,color:"#334155",marginTop:2,fontWeight:600}}>{form.jobTitle} @ {form.company}</div>
          <div style={{height:2,background:acc,borderRadius:1,margin:"8px 0",width:40}}/>
          <div style={{fontSize:11,color:"#64748b"}}>{form.email} {form.phone?"· "+form.phone:""}</div>
        </div>
      );
      if(id==="executive") return (
        <div style={{display:"flex",alignItems:"center",gap:14,fontFamily:"Arial,sans-serif",background:"#0f172a",borderRadius:10,padding:"12px 16px"}}>
          {form.avatarImg
            ? <div style={{width:44,height:44,borderRadius:10,overflow:"hidden",flexShrink:0}}><img src={form.avatarImg} style={{width:"100%",height:"100%",objectFit:"cover"}}/></div>
            : <div style={{width:44,height:44,borderRadius:10,background:form.grad,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:15,color:"#fff",flexShrink:0}}>{form.av}</div>}
          <div>
            <div style={{fontSize:13.5,fontWeight:700,color:"#fff"}}>{form.firstName} {form.lastName}</div>
            <div style={{fontSize:11,color:acc,marginTop:1}}>{form.jobTitle} · {form.company}</div>
            <div style={{fontSize:10.5,color:"rgba(255,255,255,.5)",marginTop:4}}>{form.email}</div>
          </div>
        </div>
      );
      // clean
      return (
        <div style={{display:"flex",alignItems:"center",gap:12,fontFamily:"Arial,sans-serif",padding:"10px 14px",border:`1px solid ${acc}33`,borderRadius:10,background:"#fafafa"}}>
          <div style={{width:40,height:40,borderRadius:8,background:form.grad,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:800,color:"#fff",flexShrink:0}}>{form.av}</div>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:700,color:"#0f172a"}}>{form.firstName} {form.lastName}</div>
            <div style={{fontSize:11,color:"#64748b"}}>{form.jobTitle} · {form.company}</div>
          </div>
          <div style={{fontSize:11,color:"#64748b",textAlign:"right"}}>
            <div>{form.email}</div>
            {form.phone&&<div>{form.phone}</div>}
          </div>
        </div>
      );
    };
    return (
      <div>
        <div className="ue-section-title">Email Signature</div>
        <div className="ue-section-sub">Choose a template and copy HTML for Gmail, Outlook etc.</div>

        {/* Template grid */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:20}}>
          {SIG_TEMPLATES.map(t=>(
            <div key={t.id} onClick={()=>set("sigTemplate",t.id)}
              style={{borderRadius:12,border:`2px solid ${form.sigTemplate===t.id?t.accent:"rgba(0,0,0,.08)"}`,padding:"12px",cursor:"pointer",transition:"all .18s",background:form.sigTemplate===t.id?`${t.accent}07`:"rgba(255,255,255,.72)",boxShadow:form.sigTemplate===t.id?`0 4px 16px ${t.accent}22`:"none"}}
              onMouseEnter={e=>{if(form.sigTemplate!==t.id){e.currentTarget.style.borderColor=t.accent+"44";}}}
              onMouseLeave={e=>{if(form.sigTemplate!==t.id){e.currentTarget.style.borderColor="rgba(0,0,0,.08)";}}}> 
              <div style={{fontSize:10,fontWeight:700,color:form.sigTemplate===t.id?t.accent:"#94a3b8",marginBottom:7,letterSpacing:".08em",textTransform:"uppercase"}}>{t.lbl}</div>
              <div style={{transform:"scale(.8)",transformOrigin:"top left",width:"125%",marginBottom:-14,pointerEvents:"none"}}>
                <SigPreview id={t.id}/>
              </div>
            </div>
          ))}
        </div>

        {/* Full preview */}
        <div ref={sigPreviewRef} style={{padding:"16px 18px",background:"#fff",border:"1px solid #e2e8f0",borderRadius:13,marginBottom:16,boxShadow:"0 2px 12px rgba(0,0,0,.06)"}}>
          <div style={{fontSize:10,fontWeight:700,color:"#94a3b8",letterSpacing:".08em",textTransform:"uppercase",marginBottom:12}}>Preview</div>
          <SigPreview id={form.sigTemplate}/>
        </div>

        <div style={{display:"flex",gap:9}}>
          <button className="btn bp" style={{flex:1,justifyContent:"center"}} onClick={()=>{
            const el = sigPreviewRef.current;
            if(!el) return;
            // Get just the signature HTML (skip the "Preview" label)
            const sigEl = el.querySelector(':scope > div:last-child') || el;
            const html = sigEl.outerHTML;
            navigator.clipboard?.writeText(html);
            onToast("HTML signature copied to clipboard!");
          }}>⧉ Copy HTML</button>
          <button className="btn bs" style={{flex:1,justifyContent:"center"}} onClick={()=>{
            const el = sigPreviewRef.current;
            if(!el) return;
            const canvas = document.createElement('canvas');
            const rect = el.getBoundingClientRect();
            const scale = 2;
            canvas.width = rect.width * scale;
            canvas.height = rect.height * scale;
            const ctx = canvas.getContext('2d');
            ctx.scale(scale, scale);
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, rect.width, rect.height);

            // Use foreignObject SVG to render HTML to canvas
            const svgData = `<svg xmlns="http://www.w3.org/2000/svg" width="${rect.width}" height="${rect.height}">
              <foreignObject width="100%" height="100%">
                <div xmlns="http://www.w3.org/1999/xhtml" style="font-family:Arial,sans-serif">
                  ${el.innerHTML}
                </div>
              </foreignObject>
            </svg>`;
            const img = new Image();
            img.onload = () => {
              ctx.drawImage(img, 0, 0);
              const a = document.createElement('a');
              a.href = canvas.toDataURL('image/png');
              a.download = `signature_${form.username || 'gotaps'}.png`;
              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              onToast("Signature downloaded as PNG!");
            };
            img.onerror = () => onToast("Download failed — try Copy HTML instead", "error");
            img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgData);
          }}>⬇ Download PNG</button>
        </div>
      </div>
    );
  };

  const ACC_CATALOG = [
    {type:"Sticker",   ico:"⬡",  desc:"NFC sticker for any surface",      color:"#0891b2"},
    {type:"Keychain",  ico:"🔑", desc:"NFC keychain accessory",           color:"#059669"},
    {type:"E-Badge",   ico:"🪪", desc:"Electronic NFC event badge",       color:"#7c3aed"},
    {type:"Card",      ico:"💳", desc:"Physical NFC business card",       color:"#d97706"},
    {type:"Band",      ico:"⌚", desc:"Silicone NFC wristband",           color:"#dc2626"},
    {type:"Case",      ico:"📱", desc:"NFC phone case",                   color:"#64748b"},
    {type:"Ring",      ico:"💍", desc:"NFC smart ring",                   color:"#0d9488"},
    {type:"Animal",    ico:"🐾", desc:"NFC pet tag",                      color:"#db2777"},
    {type:"Standard",  ico:"📋", desc:"Standard NFC device",              color:"#18181b"},
  ];

  // Real assigned cards loaded from /enterprise/profiles/{id}/cards.
  // Mirrors into form.accessories so the LiveCardPreview stats counter stays
  // accurate without a wider refactor.
  const [cards, setCards] = useState([]);
  const [scanType, setScanType] = useState(null);   // catalog type currently being scanned
  const [removeTarget, setRemoveTarget] = useState(null); // card pending unassign confirm
  const [toggleTarget, setToggleTarget] = useState(null); // card pending status-toggle confirm

  const syncToForm = useCallback((rows) => {
    set('accessories', rows.map((c) => ({
      id: c.id,
      type: c.type,
      uuid: c.uuid,
      status: Number(c.status) === 1 ? 'active' : 'inactive',
    })));
  }, []); // eslint-disable-line

  const refreshCards = useCallback(async () => {
    if (!member?.id) return;
    try {
      const data = await api.getProfileCards(member.id);
      setCards(data);
      syncToForm(data);
    } catch (err) {
      onToast(err.message || 'Failed to load cards', 'error');
    }
  }, [member?.id, syncToForm]); // eslint-disable-line

  useEffect(() => { refreshCards(); }, [refreshCards]);

  const handleToggle = async () => {
    const card = toggleTarget;
    if (!card) return;
    try {
      const updated = await api.toggleCard(member.id, card.id);
      const newRows = cards.map((c) => c.id === card.id ? { ...c, status: updated.status } : c);
      setCards(newRows);
      syncToForm(newRows);
      onToast(Number(updated.status) === 1 ? `${card.type} activated!` : `${card.type} deactivated`);
    } catch (err) {
      onToast(err.message || 'Toggle failed', 'error');
      throw err; // keep ConfirmModal open on failure
    }
  };

  const handleRemove = async () => {
    const card = removeTarget;
    if (!card) return;
    try {
      await api.unassignCard(member.id, card.id);
      const newRows = cards.filter((c) => c.id !== card.id);
      setCards(newRows);
      syncToForm(newRows);
      onToast(`${card.type} removed.`);
    } catch (err) {
      onToast(err.message || 'Remove failed', 'error');
      throw err; // keep ConfirmModal open so user sees it didn't succeed
    }
  };

  const SectionAccessories = () => (
    <div>
      <div className="ue-section-title">Accessories</div>
      <div className="ue-section-sub">Physical NFC devices linked to this profile · scan a QR to activate</div>

      {/* Active devices */}
      <div style={{fontSize:11,fontWeight:700,color:"#94a3b8",letterSpacing:".09em",textTransform:"uppercase",marginBottom:10}}>
        Active Devices ({cards.filter((c) => Number(c.status) === 1).length} of {cards.length})
      </div>

      {cards.length === 0 ? (
        <div style={{textAlign:"center",padding:"28px 0 20px",color:"#94a3b8"}}>
          <div style={{fontSize:32,marginBottom:8}}>💳</div>
          <div style={{fontSize:13,fontWeight:570,color:"#64748b"}}>No devices assigned</div>
          <div style={{fontSize:12,marginTop:4}}>Pick a device type below and scan its QR to activate</div>
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:9,marginBottom:20}}>
          {cards.map((c) => {
            const cat = ACC_CATALOG.find((x) => x.type === c.type) || {ico:"💳", color:"#64748b"};
            const isActive = Number(c.status) === 1;
            return (
              <div key={c.id} style={{display:"flex",alignItems:"center",gap:12,padding:"13px 16px",background:"rgba(255,255,255,.82)",border:`1.5px solid ${isActive?cat.color+"33":"rgba(0,0,0,.08)"}`,borderRadius:13,transition:"all .18s",boxShadow:isActive?`0 3px 12px ${cat.color}14`:"none"}}>
                <div style={{width:42,height:42,borderRadius:12,background:`${cat.color}14`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0}}>{cat.ico}</div>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:7}}>
                    <div style={{fontSize:13,fontWeight:660,color:"#0f172a"}}>{c.type}</div>
                    <span style={{fontSize:9.5,fontWeight:700,padding:"2px 7px",borderRadius:20,background:isActive?"rgba(5,150,105,.1)":"rgba(100,116,139,.1)",color:isActive?"#059669":"#64748b",border:`1px solid ${isActive?"rgba(5,150,105,.2)":"rgba(100,116,139,.2)"}`}}>
                      {isActive?"● ACTIVE":"○ INACTIVE"}
                    </span>
                  </div>
                  <div style={{fontSize:10.5,color:"#94a3b8",marginTop:2,fontFamily:"monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                    {c.uuid}
                  </div>
                </div>
                <div style={{display:"flex",gap:7,flexShrink:0}}>
                  <button onClick={() => setToggleTarget(c)}
                    style={{padding:"5px 12px",borderRadius:8,border:`1px solid ${isActive?"rgba(220,38,38,.2)":"rgba(5,150,105,.2)"}`,background:isActive?"rgba(220,38,38,.06)":"rgba(5,150,105,.06)",color:isActive?"#dc2626":"#059669",cursor:"pointer",fontSize:11.5,fontWeight:660,fontFamily:"var(--f)",transition:"all .15s"}}>
                    {isActive?"Deactivate":"Activate"}
                  </button>
                  <button onClick={() => setRemoveTarget(c)}
                    title="Remove from profile"
                    style={{width:30,height:30,borderRadius:8,border:"1px solid rgba(220,38,38,.18)",background:"rgba(220,38,38,.06)",cursor:"pointer",fontSize:14,color:"#dc2626",display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Catalogue → click opens scanner */}
      <div style={{fontSize:11,fontWeight:700,color:"#94a3b8",letterSpacing:".09em",textTransform:"uppercase",marginBottom:10}}>Activate New Device</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
        {ACC_CATALOG.map((at) => (
          <div key={at.type} onClick={() => setScanType(at.type)}
            style={{display:"flex",alignItems:"center",gap:11,padding:"12px 14px",background:"rgba(255,255,255,.65)",border:"1.5px dashed rgba(100,116,139,.25)",borderRadius:12,cursor:"pointer",transition:"all .15s"}}
            onMouseEnter={(e) => { e.currentTarget.style.background="rgba(255,255,255,.95)"; e.currentTarget.style.borderColor=at.color+"55"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background="rgba(255,255,255,.65)"; e.currentTarget.style.borderColor="rgba(100,116,139,.25)"; }}>
            <div style={{width:38,height:38,borderRadius:10,background:`${at.color}12`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{at.ico}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:12.5,fontWeight:620,color:"#0f172a"}}>{at.type}</div>
              <div style={{fontSize:10.5,color:"#94a3b8",marginTop:1}}>{at.desc}</div>
            </div>
            <div style={{
              width:34, height:34, borderRadius:10, flexShrink:0,
              background:"rgba(8,145,178,.1)",
              border:"1px solid rgba(8,145,178,.2)",
              display:"flex", alignItems:"center", justifyContent:"center",
              fontSize:18, color:"#0891b2",
            }}>📷</div>
          </div>
        ))}
      </div>

      {scanType && (
        <ModalScanCard
          profileId={member.id}
          expectedType={scanType}
          onClose={() => setScanType(null)}
          onAssigned={(card) => {
            setScanType(null);
            refreshCards();
            onToast(`✓ ${card.type} assigned to this profile.`);
          }}
        />
      )}

      {removeTarget && (
        <ConfirmModal
          title={`Remove ${removeTarget.type}?`}
          message={`This unlinks the ${removeTarget.type} (UUID ${removeTarget.uuid}) from this user. The card is reset to free and someone else can claim it.`}
          confirmLabel="Remove"
          danger
          onConfirm={handleRemove}
          onClose={() => setRemoveTarget(null)}
        />
      )}

      {toggleTarget && (() => {
        const willActivate = Number(toggleTarget.status) !== 1;
        return (
          <ConfirmModal
            title={willActivate ? `Activate ${toggleTarget.type}?` : `Deactivate ${toggleTarget.type}?`}
            message={willActivate
              ? `Tap users will start seeing this profile when they tap the ${toggleTarget.type} (UUID ${toggleTarget.uuid}).`
              : `Tap users will see an inactive message until you re-activate. The card stays linked to this profile.`}
            confirmLabel={willActivate ? 'Activate' : 'Deactivate'}
            danger={!willActivate}
            onConfirm={handleToggle}
            onClose={() => setToggleTarget(null)}
          />
        );
      })()}
    </div>
  );

  const SECTIONS = {
    about:       SectionAbout(),
    links:       SectionLinks(),
    capture:     SectionCapture(),
    qr:          SectionQR(),
    vbg:         SectionVBG(),
    signature:   SectionSignature(),
    accessories: SectionAccessories(),
  };

  return (
    <div className="ue-wrap-outer">
      <div className="ue-header">
        <button className="btn bs" style={{padding:"6px 13px",fontSize:12,gap:5}} onClick={onBack}>← Members</button>
        {form.avatarImg
          ? <div style={{width:34,height:34,borderRadius:"50%",overflow:"hidden",flexShrink:0,border:"2px solid rgba(255,255,255,.9)",boxShadow:"0 2px 8px rgba(0,0,0,.12)"}}><img src={form.avatarImg} style={{width:"100%",height:"100%",objectFit:"cover"}}/></div>
          : <div style={{width:34,height:34,borderRadius:"50%",background:form.grad,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:11,color:"#fff",flexShrink:0}}>{form.av}</div>}
        <div>
          <div style={{fontSize:13.5,fontWeight:700,color:"var(--t1)",letterSpacing:"-.2px"}}>{name || `${form.firstName} ${form.lastName}`}</div>
          <div style={{fontSize:11,color:"var(--t3)"}}>{form.jobTitle || "—"} · <span style={{fontFamily:"monospace",fontSize:10}}>{uuid}</span></div>
        </div>
        <div style={{marginLeft:"auto",display:"flex",gap:9,alignItems:"center"}}>
          {saved&&<span style={{fontSize:12,color:"#059669",fontWeight:600}}>✅ Saved</span>}
          <button className="btn bp" style={{padding:"7px 18px",gap:6}} onClick={handleSave}>💾 Save Profile</button>
        </div>
      </div>
      <div className="ue-body">
        <div className="ue-nav">
          <div style={{fontSize:9,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"var(--t4)",padding:"4px 12px 8px"}}>Profile</div>
          {NAV.map(n=>(
            <button key={n.id} className={`ue-nav-item${activeSection===n.id?" act":""}`} onClick={()=>setActiveSection(n.id)}>
              <div className="ue-nav-ico">{n.ico}</div><span>{n.lbl}</span>
            </button>
          ))}
        </div>
        <div className="ue-main">
          <div>{SECTIONS[activeSection]}</div>
        </div>
        {!["qr","vbg","signature","accessories"].includes(activeSection) && (
          <div className="ue-preview">
            <LiveCardPreview form={form} showCaptureForm={showCaptureForm&&activeSection==="capture"}/>
          </div>
        )}
      </div>
    </div>
  );
});

